import { Spinner } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';

export const GeneratingQuestionsLoading = () => {
  const { t } = useTranslation('audiences');

  return (
    <div className="flex flex-col items-center justify-center flex-1 gap-6">
      <Spinner size="xl" role="progressbar" className="text-primary" />
      <div className="flex flex-col items-center gap-1">
        <p className="text-base text-foreground">
          {t('focusGroup.generatingQuestionsLoading.generatingInterviewQuestions')}
        </p>
        <p className="text-sm text-muted-foreground">...</p>
      </div>
    </div>
  );
};
